"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var moment = require("moment");
var DlgCalculatePartnerRevshareCtl = /** @class */ (function (_super) {
    __extends(DlgCalculatePartnerRevshareCtl, _super);
    function DlgCalculatePartnerRevshareCtl() {
        return _super.call(this, true) || this;
    }
    DlgCalculatePartnerRevshareCtl.prototype.ResetData = function () {
        var dtFrom = moment().subtract(0, 'd').set('hour', 0).set('minute', 0);
        var dtTo = moment().add(1, 'd').set('hour', 0).set('minute', 0);
        this.DATA = {
            onYes: null,
            title: "",
            visible: false,
            date_from: dtFrom,
            date_to: dtTo,
            no_start_date: false
        };
    };
    DlgCalculatePartnerRevshareCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgCalculatePartnerRevshareCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgCalculatePartnerRevshareCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgCalculatePartnerRevshareCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgCalculatePartnerRevshareCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgCalculatePartnerRevshareCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgCalculatePartnerRevshareCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgCalculatePartnerRevshareCtl.prototype, "Title", {
        get: function () {
            return this.DATA.title;
        },
        enumerable: true,
        configurable: true
    });
    DlgCalculatePartnerRevshareCtl.prototype.SetDateFrom = function (dateFrom) {
        this.DATA.date_from = dateFrom;
        this.Update();
        return this;
    };
    DlgCalculatePartnerRevshareCtl.prototype.SetDateTo = function (dateTo) {
        this.DATA.date_to = dateTo;
        this.Update();
        return this;
    };
    DlgCalculatePartnerRevshareCtl.prototype.SetNoStartDate = function (noStartDate) {
        this.DATA.no_start_date = noStartDate;
        this.Update();
        return this;
    };
    return DlgCalculatePartnerRevshareCtl;
}(BaseController_1.BaseController));
exports.DlgCalculatePartnerRevshareCtl = DlgCalculatePartnerRevshareCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgCalculatePartnerRevshareCtl.ts
// module id = 909
// module chunks = 0